module.exports = __webpack_public_path__ + "static/media/devto.66b43d53.svg";